export default "__VITE_ASSET__vzRP$jHd__"